import { Observable } from 'rxjs/Observable';
import { ConfigService } from './../components/utils/config.service';
import { UserDetails } from './../models/userDetails.interface';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import {BaseService} from '../services/base.service';

//import { Observable } from 'rxjs/Rx'; 

// Add the RxJS Observable operators we need in this app.
//import '../../rxjs-operators';

@Injectable()

export class DashboardService extends BaseService {

  baseUrl: string = '';
  t: UserDetails = { firstName: 'CMI', lastName: '', message: '', locale: '', location: '', pictureUrl: '', facebookId: 1, gender: '', email:'', userName:'', id:'' }
  constructor(private http: Http,
              private configService:ConfigService) {
     super();
     this.baseUrl = configService.getApiURI();
      
  }
  getBranch(adminName): Observable<Response> {
    return this.http.get(this.baseUrl + "/dashboard/getBranch", adminName);
  }
  getUserDetails(): Observable<UserDetails> {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      let authToken = localStorage.getItem('auth_token');
      console.log(authToken);
      
      if (!authToken){
        return Observable.of(this.t);
      }
      else {
      headers.append('Authorization', `Bearer ${authToken}`);
  
    return this.http.get(this.baseUrl + "/dashboard/home",{headers})
      .map(response => response.json())
      .catch(this.handleError);
      }
  }  
}



// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts